<template>
  <div class="sticky md:relative top-12 md:top-0 z-20 bg-white py-2">
    <div class="font-bold text-lg md:text-2xl">{{ dateFormatted || dayjs(props.date).format('D MMMM') }}</div>
    <div class="text-sm uppercase font-medium opacity-50">{{ dateFormatted ? dayjs(date).format('D MMMM') : dayjs(date).format('dddd') }}</div>
  </div>
</template>

<script setup>
const dayjs = useDayjs()
const { t } = useI18n()

const props = defineProps({
  date: {
    type: String,
    default: ''
  }
})

const dateFormatted = computed(() => dayjs(props.date).isToday()
  ? useUcFirst(t('shared.today'))
  : dayjs(props.date).isTomorrow()
    ? useUcFirst(t('shared.tomorrow'))
    : dayjs(props.date).isSame(dayjs(), 'week')
      ? useUcFirst(dayjs(props.date).format('dddd'))
      : null)
</script>

<style lang="scss" scoped>
.card {
  @apply w-full h-full bg-mist flex flex-col;

  &--featured {
    @apply flex-row items-center;
  }

  &__media {

  }
}
</style>